import { catUsuariosNormalize }                 from '../Objetos/CatUsuariosModel';
import { catRolesNormalize }                    from '../Objetos/CatRolesModel';
import { catAtributosNormalize }                from '../Objetos/CatAtributosModel';
import { catOperadoresABACNormalize }           from '../Objetos/CatOperadoresABACModel';
import { catPermisosNormalize }                 from '../Objetos/CatPermisosModel';
import { catRecursosNormalize }                 from '../Objetos/CatRecursosModel';
import { catProyectosNormalize }                from '../Objetos/CatProyectosModel';
import { perfilesNormalize }                    from '../Objetos/PerfilesModel';
import { politicasABACNormalize }               from '../Objetos/PoliticasABACModel';
import { rolesRecursosPermisosNormalize }       from '../Objetos/RolesRecursosPermisosModel';
import { usuarioRolNormalize }                  from '../Objetos/UsuarioRolModel';
import { atributoUsuarioNormalize }             from '../Objetos/AtributoUsuarioModel';
import { empleadosAreaNegocioNormalize }        from '../Objetos/EmpleadosAreaNegocioModel';
import { empleadosNivelJerarquicoNormalize }    from '../Objetos/EmpleadosNivelJerarquicoModel';
import { empleadosProyectosNormalize }          from '../Objetos/EmpleadosProyectosModel';
import { empleadosPuestoNormalize }             from '../Objetos/EmpleadosPuestoModel';
import { empleadosTurnosNormalize }             from '../Objetos/EmpleadosTurnosModel';
import { empleadosZonasGeograficasNormalize }   from '../Objetos/EmpleadosZonasGeograficasModel';
import { moduloSeguridadNormalize }             from '../Objetos/CatModulosModel';
import { menuNormalize }                        from '../Objetos/CatMenusModel';
import { modulosObjectoNormalize }              from '../Objetos/ModulosObjetosModel';
import { menusObjetoNormalize }                 from '../Objetos/MenusObjetosModel';

// General (modelos foráneos copiados a Seguridad)
import { personasNormalize }                    from '../Objetos/Foraneos/PersonasModel';
import { empleadosNormalize }                   from '../Objetos/Foraneos/EmpleadosModel';
import { puestoNormalize }                      from '../Objetos/Foraneos/PuestoModel';
import { unidadesOrgEmpleadoNormalize }         from '../Objetos/Foraneos/UnidadesOrgEmpleadoModel';
import { catUnidadesOrgNormalize }              from '../Objetos/Foraneos/CatUnidadesOrgModel';
import { zonasGeograficasNormalize }            from '../Objetos/Foraneos/ZonasGeograficasModel';
import { nivelJerarquicoNormalize }             from '../Objetos/Foraneos/NivelJerarquicoModel';
import { areaNegocioNormalize }                 from '../Objetos/Foraneos/AreaNegocioModel';

export const Models = {
    usuarios:                       (u) => catUsuariosNormalize(u),
    roles:                          (r) => catRolesNormalize(r),
    catAtributos:                   (x) => catAtributosNormalize(x),
    catOperadoresABAC:              (x) => catOperadoresABACNormalize(x),
    catPermisos:                    (x) => catPermisosNormalize(x),
    catRecursos:                    (x) => catRecursosNormalize(x),
    catProyectos:                   (x) => catProyectosNormalize(x),
    perfiles:                       (x) => perfilesNormalize(x),
    politicasABAC:                  (x) => politicasABACNormalize(x),
    rolesRecursosPermisos:          (x) => rolesRecursosPermisosNormalize(x),
    usuarioRol:                     (x) => usuarioRolNormalize(x),
    atributoUsuario:                (x) => atributoUsuarioNormalize(x),
    empleadosAreaNegocio:           (x) => empleadosAreaNegocioNormalize(x),
    empleadosNivelJerarquico:       (x) => empleadosNivelJerarquicoNormalize(x),
    empleadosProyectos:             (x) => empleadosProyectosNormalize(x),
    empleadosPuesto:                (x) => empleadosPuestoNormalize(x),
    empleadosTurnos:                (x) => empleadosTurnosNormalize(x),
    empleadosZonasGeograficas:      (x) => empleadosZonasGeograficasNormalize(x),
    moduloSeguridad:                (x) => moduloSeguridadNormalize(x),
    menu:                           (x) => menuNormalize(x),
    modulosTopBar:                  (x) => modulosObjectoNormalize(x),
    menusSideBar:                   (x) => menusObjetoNormalize(x),

    // General (modelos compartidos con el módulo General)
    personas:              (x) => personasNormalize(x),
    empleado:              (x) => empleadosNormalize(x),
    puesto:                (x) => puestoNormalize(x),
    unidadOrgEmpleado:     (x) => unidadesOrgEmpleadoNormalize(x),
    unidadesOrg:           (x) => catUnidadesOrgNormalize(x),
    zonasGeograficas:      (x) => zonasGeograficasNormalize(x),
    nivelesJerarquicos:    (x) => nivelJerarquicoNormalize(x),
    areasNegocios:         (x) => areaNegocioNormalize(x),
}